/*
 * Potzillas — O nás
 * Count-up animace čísel (KPI). Spustí se, když skupina [data-count-group]
 * scrolne do view, a odpočítá od 0 do cíle.
 * - respektuje prefers-reduced-motion (rovnou ukáže finální hodnotu)
 * - bez JS / bez IntersectionObserveru ukáže rovnou finální hodnotu (SSR fallback)
 * - idempotentní (lze volat opakovaně, i po shopify:section:load)
 */
(function () {
  var reduce = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function format(n, style) {
    n = Math.floor(n);
    var s = n.toString();
    if (style === 'none') return s;
    var sep = style === 'comma' ? ',' : style === 'dot' ? '.' : ' '; // 'space' = pevná mezera
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animate(el) {
    if (el.dataset.counted === '1') return;
    el.dataset.counted = '1';

    var target = parseInt((el.getAttribute('data-count-target') || '').replace(/\D/g, ''), 10) || 0;
    var duration = parseInt(el.getAttribute('data-count-duration'), 10) || 1600;
    var suffix = el.getAttribute('data-count-suffix') || '';
    var fmt = el.getAttribute('data-count-format') || 'space';

    if (reduce) {
      el.textContent = format(target, fmt) + suffix;
      return;
    }

    var t0 = performance.now();
    function tick(now) {
      var p = Math.min(1, (now - t0) / duration);
      var current = Math.round(target * easeOutCubic(p));
      el.textContent = format(current, fmt) + suffix;
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = format(target, fmt) + suffix;
    }
    requestAnimationFrame(tick);
  }

  function initGroup(group) {
    if (group.dataset.countReady === '1') return;
    group.dataset.countReady = '1';

    var els = Array.prototype.slice.call(group.querySelectorAll('[data-count-target]'));
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(animate);
      return;
    }

    // Vynuluj hned (zabrání probliknutí SSR finální hodnoty u JS prohlížečů)
    els.forEach(function (el) {
      var fmt = el.getAttribute('data-count-format') || 'space';
      el.textContent = format(0, fmt) + (el.getAttribute('data-count-suffix') || '');
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          els.forEach(animate);
          io.disconnect();
        }
      });
    }, { threshold: 0.3 });

    io.observe(group);
  }

  function init() {
    document.querySelectorAll('[data-count-group]').forEach(initGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
